import { Injectable, InjectionToken, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

export interface DynamicOpenCloseTemplateRef {
  id: string;
  templateRef: TemplateRef<any> | undefined;
}

export const DYNAMIC_OPEN_CLOSE_TEMPLATE_DATA: InjectionToken<Observable<any>> = new InjectionToken<Observable<any>>(
  'com.vendasta.galaxy.side-drawer.dynamic-open-close-template-ref.data',
);

@Injectable({ providedIn: 'root' })
export class DynamicOpenCloseTemplateRefService {
  private templateMap = new Map<string, TemplateRef<any>>();
  private openTemplateId$$ = new BehaviorSubject<string>('');
  openTemplate$: Observable<DynamicOpenCloseTemplateRef>;

  private _open$$ = new BehaviorSubject<boolean>(false);
  private _open$ = this._open$$.asObservable();

  private _dynamicOpenCloseTemplateData$$: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _dynamicOpenCloseTemplateData$ = this._dynamicOpenCloseTemplateData$$.asObservable();

  public static dynamicOpenCloseTemplateData$(svc: DynamicOpenCloseTemplateRefService): Observable<any> {
    return svc._dynamicOpenCloseTemplateData$;
  }

  get open$(): Observable<boolean> {
    return this._open$;
  }

  constructor() {
    this.openTemplate$ = this.openTemplateId$$.pipe(
      map((id) => {
        const templateRef = this.templateMap.get(id);
        return {
          id: templateRef ? id : '',
          templateRef: templateRef,
        };
      }),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );
  }

  close(): void {
    this._open$$.next(false);
  }

  registerTemplate(id: string, template: TemplateRef<any>): void {
    this.templateMap.set(id, template);
  }

  open(id: string, data?: any): void {
    if (data) {
      this._dynamicOpenCloseTemplateData$$.next(data);
    }
    window.setTimeout(() => {
      this.openTemplateId$$.next(id);
      this._open$$.next(true);
    });
  }

  toggle(id: string, data?: any): void {
    if (data) {
      this._dynamicOpenCloseTemplateData$$.next(data);
    }
    if (this._open$$.getValue()) {
      this.close();
    } else {
      this.open(id);
    }
  }
}
